<template>
  <v-layout
      column
      fill-height
      :class="isMobile ? 'white' : 'primary'"
  >
    <v-flex xs12>
      <v-layout row fill-height>
        <v-flex xs7 fill-height v-if="!isMobile">
          <v-layout column fill-height justify-space-around style="width: 80%; margin: auto">
            <v-flex shrink>
              <img src="../../public/LogoAllWhite.svg"/>
            </v-flex>
          </v-layout>
        </v-flex>
        
        <v-flex :xs5="!isMobile" :x12="isMobile" fill-height :class="!isMobile ? 'loginBackWhiteArrow' : ''">
          
          
          <v-layout column align-center justify-center fill-height>
            <v-flex v-if="isMobile" shrink style="max-width: 80%; padding-bottom: 80px">
              <img src="../../public/logoSimple.svg" alt="logo" style="width: 100%"/>
            </v-flex>
            <v-flex shrink style="max-width: 400px">
              <v-form ref="login">
                <v-text-field
                    color="secondary"
                    single-line
                    v-model="userName"
                    label="Email Address"
                    :rules="inputRules"
                    placeholder="Email Address"
                    class="py-2 pr-3"
                    hide-details
                    @keyup.enter="enterUserName"
                >
                  <template slot="prepend">
                    <div class="pt-1">
                      <v-icon class="pa-0 ma-0" color="secondary">account_circle</v-icon>
                    </div>
                  </template>
                </v-text-field>
                
                <v-text-field
                    @keyup.enter="loginStart"
                    color="secondary"
                    single-line
                    v-model="password"
                    :type="showPassword ? 'text' : 'password'"
                    label="Password"
                    :rules="inputRules"
                    placeholder="Password"
                    class="py-2 pr-3"
                    ref="passwordField"
                    :append-icon="!blankString(password) ? (showPassword ? 'visibility' : 'visibility_off') : null"
                    @click:append="showPassword = !showPassword"
                >
                  <template slot="prepend">
                    <div class="pt-1">
                      <v-icon class="pa-0 ma-0" color="secondary">vpn_key</v-icon>
                    </div>
                  </template>
                </v-text-field>
                
<!--                <div-->
<!--                    id="captchaDiv"-->
<!--                    class="c-d-flex c-justify-center"-->
<!--                ></div>-->
                
                <div class="g-recaptcha"
                     data-sitekey="6LfXXZApAAAAAC9L3mhu4PXa3kgrAPmvN_qBmFIF"
                     data-size="invisible"
                     data-callback="captchaExec"
                     data-expired-callback="captchaExpired"
                     data-error-callback="captchaExpired"
                     data-badge="bottomleft"
                >
                </div>
                
                <div style="width: 100%" class="text-xs-center caption red--text py-2" v-if="loginMessage != null">
                  {{ loginMessage }}
                </div>
                
                <v-layout row align-center justify-space-between class="py-2">
                  <v-flex shrink>
                    <span class="font-weight-light primary--text caption">*Google Chrome Web Browser Recommended</span>
                  </v-flex>
                  
                  <v-flex shrink>
                    <v-btn :loading="loginPending" @click="loginStart" color="secondary">
                      <span>Login</span>
                      <v-icon right>navigate_next</v-icon>
                    </v-btn>
                  </v-flex>
                  
                </v-layout>
              </v-form>
            </v-flex>
          </v-layout>
        
        </v-flex>
      </v-layout>
    </v-flex>
    
    <v-snackbar v-model="loginFail" bottom>
      <span>Invalid Login</span>
      <v-btn color="secondary" flat @click="loginFail = false">
        Close
      </v-btn>
    </v-snackbar>
    
    <two-factor
        :config="twoFactorConfig"
        v-if="!!twoFactorConfig"
        :getOS="getOS"
        :setCookie="setCookie"
        @OTPSuccess="OTPLogin($event)"
    />
    <!--<v-flex shrink style="z-index: 100; background: black; color: white;" class="pa-1 text-xs-center pr-3">-->
    <!--<span class="caption font-weight-light">©2019 Tasklogix (Pty) Ltd</span>-->
    <!--</v-flex>-->
    
    <!--<v-dialog v-model="showWaitOffice" persistent width="300" lazy>-->
    <!--<v-card flat>-->
    <!--<v-card-title class="pa-1 pl-2">-->
    <!--<span class="subheading font-weight-light primary&#45;&#45;text">Logging Into Your Office Account</span>-->
    <!--</v-card-title>-->
    <!--<v-divider></v-divider>-->
    
    <!--<v-card-text class="pa-5 text-xs-center">-->
    <!--<v-progress-circular-->
    <!--:size="40"-->
    <!--:width="5"-->
    <!--color="primary"-->
    <!--indeterminate-->
    <!--&gt;</v-progress-circular>-->
    <!--</v-card-text>-->
    <!--</v-card>-->
    <!--</v-dialog>-->
    
    <call-us
        phonesystem-url="https://smitk.3cx.co.za:5001"
        id="wp-live-chat-by-3CX"
        minimized="true"
        animation-style="noanimation"
        party="LiveChat836156"
        minimized-style="bubbleright"
        allow-call="false"
        allow-video="false"
        allow-soundnotifications="true"
        enable-mute="true"
        enable-onmobile="true"
        offline-enabled="true"
        enable="true"
        ignore-queueownership="false"
        authentication="both"
        operator-name="Tasklogix Support"
        show-operator-actual-name="true"
        aknowledge-received="true"
        operator-icon="data:image/png;base64,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"
        gdpr-enabled="false"
        message-userinfo-format="both"
        message-dateformat="both"
        lang="en"
        button-icon-type="default"
        greeting-visibility="none"
        greeting-offline-visibility="none"
        chat-delay="2000"
        enable-direct-call="false"
        enable-ga="false"
        class="callUs"
    ></call-us>
  </v-layout>
</template>

<script>

import TwoFactor from "@/views/twoFactor";

function getOS() {
  var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null;
  
  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
  } else if (!os && /Linux/.test(platform)) {
    os = 'Linux';
  }
  
  return os;
}

function setCookie(cname, cvalue, exdays = null) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = `${cname}=${cvalue};${expires};path=/;domain=${window.location.hostname};secure`;
  // document.cookie = cname + "=" + cvalue + ";";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

import {eventBus} from '../main';
import {codeBaseMixin} from '../codeBaseMixin';
import axios from 'axios';

let tokenMan = require('../tokenManSite');

export default {
  components: {TwoFactor},
  mixins: [codeBaseMixin],
  data() {
    return {
      userName: '',
      password: '',
      gmailTokenCode: '',
      officeTokenCode: '',
      inputRules: [
        v => !!v || 'This field is required',
        v => v.length >= 6 || 'Minimum length is 6 characters'
      ],
      loginPending: false,
      loginFail: false,
      showWaitOffice: false,
      showPassword: false,
      loginMessage: null,
      isMobile: false,
      twoFactorConfig: null,
      recaptchaCode: null
    }
  },
  
  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize, {passive: true})
    window.captchaExec = this.captchaExec;
    window.captchaExpired = this.captchaExpired;
    this.loadReCaptcha()
  },
  beforeDestroy() {
    if (typeof window === 'undefined') return
    window.removeEventListener('resize', this.onResize, {passive: true})
  },
  
  methods: {
    
    executeHere() {
      grecaptcha.execute();
    },
    
    loadReCaptcha() {
      window.onloadCallback = this.captchaLoaded;
      const script = document.createElement('script');
      // script.src = "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit";
      script.src = "https://www.google.com/recaptcha/api.js";
      document.head.appendChild(script);
    },
    
    loginStart() {
      this.loginPending = true
      grecaptcha.execute();
    },
    
    captchaExpired(data) {
      console.log(data)
      this.recaptchaCode = null
      this.loginPending = false
    },
    
    captchaExec(data) {
      this.recaptchaCode = data
      this.login();
    },
    
    
    getOS: getOS,
    setCookie: setCookie,
    
    onResize() {
      this.isMobile = window.innerWidth < 900
    },
    
    enterUserName() {
      if (this.password == null || this.password === '') {
        this.$refs.passwordField.focus();
      } else {
        this.loginStart();
      }
    },
    
    OTPLogin(token) {
      this.twoFactorConfig = null;
      tokenMan.initialize(token);
      this.loginMessage = null;
      eventBus.$emit('showHideNav', true);
      this.$emit('succesfullLogin', {gmailTokenCode: this.gmailTokenCode, officeTokenCode: this.officeTokenCode});
      this.loginPending = false;
    },
    
    login() {
      
      if (!this.userName)
        return this.loginMessage = 'Username Required';
      
      if (!this.password)
        return this.loginMessage = 'Password Required';
      
      if (!this.recaptchaCode)
        return this.loginMessage = 'reCAPTCHA Required';
      
      // console.log(getOS())
      // console.log('Existing', getCookie(this.username))
      // setCookie(this.username, 'WARA WARA WARA')
      
      this.loginPending = true;
      if (this.$refs.login.validate()) {
        this.fetch({
          method: 'POST',
          url: `/login`,
          body: JSON.stringify({
            user: this.userName,
            password: this.password,
            deviceID: getCookie(this.userName.toLowerCase()),
            recaptchaCode: this.recaptchaCode,
            os: getOS()
          })
        }, false)
            .then((data) => {
              switch (parseInt(data.status)) {
                case -1: {
                  this.twoFactorConfig = data.message
                  break;
                }
                case 0: {
                  tokenMan.initialize(data.message);
                  this.loginMessage = null;
                  eventBus.$emit('showHideNav', true);
                  this.$emit('succesfullLogin', {
                    gmailTokenCode: this.gmailTokenCode,
                    officeTokenCode: this.officeTokenCode
                  });
                  break;
                }
                case 1: {
                  this.loginMessage = 'Malformed Request';
                  break;
                }
                case 2: {
                  this.loginMessage = 'User Not Found';
                  break;
                }
                case 3: {
                  this.loginMessage = 'Invalid Username/Password Combination';
                  break;
                }
                case 4: {
                  this.loginMessage = 'Token Error';
                  break;
                }
                case 5: {
                  this.loginMessage = data.message;
                  break;
                }
                
              }
              
              this.loginPending = false;
            })
            .catch((e) => {
              // eslint-disable-next-line
              console.log(e)
              this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
              this.loginPending = false;
            }).finally(() => {
          this.loginPending = false;
        })
      }
    },
    getOfficeToken(userKey, token, officeCode) {
      this.showWaitOffice = true;
      
      axios.request({
        method: "get",
        url: `/microsoft/getToken/${officeCode}`,
        data: null,
        headers: {
          "tl-user-key": userKey,
          "tl-token": token
        }
      }).then(data => {
        tokenMan.initialize(data.data);
        this.loginMessage = null;
        eventBus.$emit('showHideNav', true);
        this.$emit('succesfullLogin', {gmailTokenCode: this.gmailTokenCode, officeTokenCode: this.officeTokenCode});
      })
          .catch(e => {
            console.log(e)
            this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
            this.showWaitOffice = false;
          })
      
      
      // this.fetch({method: 'GET', url:``})
      //     .then(() => {
      //         window.location.href = `${this.baseServerAddress}#/dashboard/${accessCode}`;
      //     })
      //     .catch((e) => {
      //         // eslint-disable-next-line
      //         console.log(e)
      //         this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
      //         this.showWaitOffice = false;
      //     })
      
    },
    
    async getOfficeSmtpToken(config) {
      try {
        this.showWaitOffice = true;
        const data = await this.$newReq('POST', 'oSmtpLink', config, false)
        // tokenMan.initialize(data.data);
        // this.loginMessage = null;
        // eventBus.$emit('showHideNav', true);
        // this.$emit('succesfullLogin', { gmailTokenCode: this.gmailTokenCode, officeTokenCode: this.officeTokenCode});
        console.log({data})
      } catch (e) {
        console.log(e)
      } finally {
        this.showWaitOffice = false
      }
    }
  },
  
  created() {
    eventBus.$emit('showHideNav', false);
    // let url =new URL(document.location.href);
    //
    // let state = url.searchParams.get("state");
    //
    // if (state == 'office') {
    //     this.officeTokenCode = url.searchParams.get('code')
    // } else {
    //     this.gmailTokenCode = url.searchParams.get("code");
    // }
    
    var urlParams = new URLSearchParams(window.location.search);
    
    
    if (urlParams.has('state') && urlParams.has('code')) {
      const state = urlParams.get('state')
      const code = urlParams.get('code')
      if (state.match(/osmtplink-/gi)) {
        this.getOfficeSmtpToken({state, code})
      } else {
        switch (urlParams.get('state').substring(0, 1)) {
          case 'o' : {
            //o-u-1-stage1%40tasklogix.co.za-t-5hLWfWVPLJAwkQGf2HtUYivwdqm2iQiZhXQ2XVSdCUzJWkX9UgfoqmtsdGJPb61CCDrMgWDMbm5uZJEjx5t1yJg5
            let state = urlParams.get('state')
            let sUserKey = state.substring(state.indexOf('-u-') + 3, state.indexOf('-t-'));
            let sToken = state.substring(state.indexOf('-t-') + 3, state.length);
            
            this.getOfficeToken(
                sUserKey, sToken, urlParams.get('code')
            );
            break;
          }
          case 'g' : {
            // Gmail Code Will Come Here
            break;
          }
        }
      }
      
    } else {
      if (urlParams.has('code')) {
        let url = new URL(document.location.href);
        
        this.gmailTokenCode = url.searchParams.get("code");
      }
      
      if (urlParams.has('user_key') && urlParams.has('token') && urlParams.has('exp')) {
        
        const params = {
          userKey: urlParams.get('user_key'),
          token: urlParams.get('token'),
          exp: parseInt(urlParams.get('exp')),
        }
        history.pushState({}, '', window.location.pathname);
        
        tokenMan.initialize(params);
        this.loginMessage = null;
        eventBus.$emit('showHideNav', true);
        this.$emit('succesfullLogin', {gmailTokenCode: this.gmailTokenCode, officeTokenCode: this.officeTokenCode});
      }
    }
  },
  
}
</script>

<style scoped>
.loginBackRight {
  background-image: url('../../public/lineBack.svg');
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
  background-size: cover;
}

.loginBackWhiteArrow {
  background-image: url('../../public/lineBackWhite.svg');
  background-repeat: no-repeat;
  background-size: cover;
}


</style>
